import React from 'react'
import { Modal } from 'antd'
import _noop from 'lodash/noop'
import PropTypes from 'prop-types'

import { TITLE, MODAL_WIDTH } from './emrSignInModal.constants'
import styles from './emrSignInModal.module.scss'

const EMRSignInModal = ({ isVisible, closePopup, redirectToEmr }) => {
  return (
    <Modal
      width={MODAL_WIDTH}
      title={TITLE}
      closable={false}
      visible={isVisible}
      className={styles.container}
      onCancel={closePopup}
      onOk={redirectToEmr}
      cancelText='Skip'
    >
      <div className={styles.content}>You’ll be redirected for a moment to sign into your EMR, then directed back.</div>
    </Modal>
  )
}

EMRSignInModal.propTypes = {
  isVisible: PropTypes.bool,
  closePopup: PropTypes.func,
  redirectToEmr: PropTypes.func
}

EMRSignInModal.defaultProps = {
  isVisible: false,
  closePopup: _noop,
  redirectToEmr: _noop
}

export default EMRSignInModal
